import React from 'react';
import Race from './Race';

const RaceStartList = props => {
  return <Race startList={true} {...props} />;
};

export default RaceStartList;
